export const CURRENCY_SYMBOL = "BDT";


export const APP_NAME = "France Bet";
